import React, { useContext, useState, ChangeEvent, useEffect } from 'react'
import { Paper, Typography } from '@material-ui/core'
import AuthContext from './AuthContext'
import { CircularProgress, TextField, Button, Grid, Checkbox, FormControl, FormControlLabel, FormHelperText } from '@material-ui/core'
import { useLocalStorage } from 'use-hooks'

function onChange(setter: (val: string)=>void) {
  return function _onChange(evt: ChangeEvent<HTMLInputElement>) {
    setter(evt.target.value)
  }
}

function onCheck(setter: (val: boolean)=>void) {
  return function _onCheck(evt: ChangeEvent<{}>, checked: boolean) {
    setter(checked)
  }
}

// backgroundColor: 'rgb(38, 173, 166)', width: '100%', height: '100%',

function Center({ children, style }: { children: any, style: React.CSSProperties | undefined }) {
  return <Grid
    container
    direction='column'
    justify='center'
    alignItems='center'
    style={{ ...style }}>
    {children}
  </Grid>
}

// function login(email: string, password: string) {
// }

export default function SigninPage() {
  const { login, error } = useContext(AuthContext)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [rememberme, setRememberme] = useState(false)
  const [rembered, setRemembered] = useLocalStorage('remember-me', null as { username:string, pwd: string } | null)
  const [loading, setLoading] = useState(false)

  async function _login(username: string, password: string, remember: boolean) {
    setLoading(true)
    try {
      if (rememberme) {
        setRemembered({
          username: username,
          pwd: password,
        })
      }
      return await login(username, password, remember)
    } catch (err) {
      setLoading(false)
      console.error(err)
      throw err
    }
  }
  
  useEffect(() => {
    if (!rembered) {
      return
    }
    _login(rembered.username, rembered.pwd, true)
  }, [rembered && rembered.username, rembered && rembered.pwd])

  return <form><Center style={{ backgroundColor: 'rgb(38, 173, 166)', width: '100vw', height: '100vh', padding: '16px' }}>
    <Paper style={{ width: '300px', height: '485px', padding: '32px' }}>
    {
      loading ? <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </div> : 
        <Center style={{ width: '100%', height: '100%' }}>
          <Typography variant='h5' paragraph={true} style={{ alignSelf: 'flex-start' }}>
            musicMe playlist manager
          </Typography>
          {/* <Typography variant='body2' paragraph={true}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
          </Typography> */}
          <FormControl error={!!error} style={{ width: '100%' }}>
            <TextField
              error={!!error}
              value={username}
              onChange={onChange(setUsername)}
              type='email'
              margin='normal'
              variant='outlined'
              label='Adresse e-mail'
              style={{ width: '100%' }}
              autoFocus
            />
            {/* <FormHelperText>{error}</FormHelperText> */}
          </FormControl>
          <FormControl error={!!error} style={{ width: '100%' }}>
            <TextField
              error={!!error}
              value={password}
              onChange={onChange(setPassword)}
              type='password'
              margin='normal'
              variant='outlined'
              label='Mot de passe'
              style={{ width: '100%' }}
            />
            <FormHelperText>{error}</FormHelperText>
          </FormControl>
          <FormControlLabel style={{ alignSelf: 'flex-start' }}
            control={
              <Checkbox
                checked={rememberme}
                value='remember-me'
                color='primary'
              />
            }
            label='Se souvenir de moi'
            labelPlacement='end'
            onChange={onCheck(setRememberme)}
          />
          <Button
            variant='contained'
            color='primary'
            style={{ alignSelf: 'flex-end', marginTop: '16px' }}
            disabled={loading}
            type='submit'
            onClick={() => _login(username, password, rememberme)}>
            { loading ? 'Chargement...' : 'Se connecter'}
          </Button>
        </Center>
    }
    </Paper>
  </Center>
  </form>
}